import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ManageProjectComponent from '../../components/ManageProjectComponent/ManageProjectComponent'

const ManageProjects = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManageProjectComponent/>
                </div>
            </div>
        </div>
    )
}

export default ManageProjects
